import React from 'react';
import './ButtonGroup.css';

const ButtonGroup = React.memo(({ children }) => (
  <menu className="buttonGroup">{children && children}</menu>
));

ButtonGroup.propTypes = {};

ButtonGroup.defaultProps = {};

export default ButtonGroup;
